// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('order.purchaseorderanalysis',{
        url: '/purchaseorderanalysis?{s}&{page}&{limit}&{a}&{i}&{ac}',
        templateUrl: 'main/order/purchaseorderanalysis/purchaseorderanalysis.tpl.html',
        controller: 'PurchaseOrderAnalysisController as vm',
        resolve: {
            suppliers: companyResolver,
            mainGroups: mainGroupResolver,
            articleCollections: articleCollectionResolver
        }
    });
}

/*
s: supplier id
limit: number of results per page
a: article collection id
i: include inactive articles (0 = false, 1 = true)
page: current page
ac: show all collections
*/

// @ngInject
function companyResolver(PurchaseOrderAnalysisApiService) {
    return PurchaseOrderAnalysisApiService.getSupplierBriefs();
}

// @ngInject
function mainGroupResolver(PurchaseOrderAnalysisApiService) {
    return PurchaseOrderAnalysisApiService.getMainGroupBriefs();
}

// @ngInject
function articleCollectionResolver(PurchaseOrderAnalysisApiService) {
    return PurchaseOrderAnalysisApiService.getArticleCollectionBriefs();
}

// @ngInject
function PurchaseOrderAnalysisController($scope, $state, $stateParams, $translate,
    suppliers, mainGroups, articleCollections, PurchaseOrderAnalysisApiService, confirmationDialogService, purchaseOrderAnalysisFilterDialogService,
    loadSpinnerService, ToasterService) {
    var vm = this;

    //Properties
    vm.purchaseOrderAnalysisArticles = [];
    vm.purchaseOrderAnalysisArticlesLength = 0;
    vm.completeListOfPurchageAnalysisRows = [];
    vm.showWeeks = false;
    vm.showProduct = false;
    vm.suppliers = suppliers;
    vm.allMainGroups = mainGroups;
    vm.mainGroups = [];
    vm.articleCollections = articleCollections;
    vm.weekLimit = [24, 20, 16, 12, 8, 4];
    vm.selectedWeekLimit = undefined;
    vm.keepProductTogether = true;
    vm.numberOfResultsPerPage = [50, 100, 200, 300, 400, 500];
    vm.selectedMainGroup = {};

    //Pick show all article collections from state params if possible
    vm.showAllCollections = $stateParams.ac !== undefined && $stateParams.ac === '1' ? true : false;
    //Pick include inactive articles from state params if possible
    vm.includeInactive = $stateParams.i !== undefined && $stateParams.i === '1' ? true : false;
    //Pick selected supplier from state params if possible
    vm.selectedSupplier = $stateParams.s !== undefined && $stateParams.s > 0 ? _.find(vm.suppliers, function(s) { return '' + s.id === $stateParams.s; }) : {};
    //Pick selected article collection from state params if possible
    vm.selectedArticleCollection = $stateParams.a !== undefined && $stateParams.a > 0 ? _.find(vm.articleCollections, function(a) { return '' + a.id === $stateParams.a; }) : _.find(vm.articleCollections, {'isCurrent': true});
    //Pick current page from state params if possible
    vm.currentPage = $stateParams.page !== undefined && $stateParams.page > 0 ? parseInt($stateParams.page) : 1;
    //Pick selected number of results from state params if possible
    vm.selectedNumberOfResultsPerPage = $stateParams.limit !== undefined && $stateParams.limit > 0 ? parseInt($stateParams.limit) : 300;

    //Methods
    vm.toggleShowProduct = toggleShowProduct;
    vm.canCreateOrder = canCreateOrder;
    vm.createOrder = createOrder;
    vm.calculateMonth = calculateMonth;
    vm.toggleArticleRows = toggleArticleRows;
    vm.sumRowsWeek = sumRowsWeek;
    vm.sumRowsMonth = sumRowsMonth;
    vm.sumQuantityToOrder = sumQuantityToOrder;
    vm.sumTotalQuantityToOrder = sumTotalQuantityToOrder;
    vm.sumWarehouseStock = sumWarehouseStock;
    vm.sumStoreStock = sumStoreStock;
    vm.sumOrderedQuantity = sumOrderedQuantity;
    vm.sumWeeksLeftInStock = sumWeeksLeftInStock;
    vm.sumMonthsLeftInStock = sumMonthsLeftInStock;
    vm.sumRowWeeksLeftInStock = sumRowWeeksLeftInStock;
    vm.sumRowMonthsLeftInStock = sumRowMonthsLeftInStock;
    vm.weeksLeftInStockAfterOrder = weeksLeftInStockAfterOrder;
    vm.monthsLeftInStockAfterOrder = monthsLeftInStockAfterOrder;
    vm.clearFilter = clearFilter;
    vm.filterAnalysisRows = filterAnalysisRows;
    vm.averageSalesPerMonth = averageSalesPerMonth;
    vm.averageSalesPerWeek = averageSalesPerWeek;
    vm.showChangedWeekAverage = showChangedWeekAverage;
    vm.showChangedMonthAverage = showChangedMonthAverage;
    vm.showFilterDialog = showFilterDialog;
    vm.goToFirst = goToFirst;
    vm.goToPrevious = goToPrevious;
    vm.goToNext = goToNext;
    vm.goToLast = goToLast;
    vm.getPageNumber = getPageNumber;

    activate();

    function activate() {
        if ($stateParams.s && $stateParams.s > 0) {
            loadPurchaseOrderAnalysis();
        } else {
            showFilterDialog();
        }
    }

    function getPageNumber(rel) {
        if (vm.links && vm.links.length > 0) {
            var pageNumber = _.find(vm.links, function(o) {
                return o.rel === rel;
            });
            return pageNumber.page;
        } else {
            return '';
        }
    }
    function goToFirst() {
        // 1: {href: "order/purchaseorderanalysis?limit=300&page=1&s=15&a=43&i=0&ac=0", rel: "first", type: "GET"}
        var first = _.find(vm.links, function(o) {
            return o.rel === 'first';
        });

        $state.go('order.purchaseorderanalysis', {
            s: vm.selectedSupplier.id,
            limit: first.limit,
            a: vm.selectedArticleCollection.id,
            page: first.page,
            i: vm.includeInactive ? '1': '0',
            ac: vm.showAllCollections ? '1': '0'
        });
    }
    function goToPrevious() {
        // 1: {href: "order/purchaseorderanalysis?limit=300&page=1&s=15&a=43&i=0&ac=0", rel: "previous", type: "GET"}
        var previous = _.find(vm.links, function(o) {
            return o.rel === 'previous';
        });

        $state.go('order.purchaseorderanalysis', {
            s: vm.selectedSupplier.id,
            limit: previous.limit,
            a: vm.selectedArticleCollection.id,
            page: previous.page,
            i: vm.includeInactive ? '1': '0',
            ac: vm.showAllCollections ? '1': '0'
        });
    }
    function goToNext() {
        // 3: {href: "order/purchaseorderanalysis?limit=300&page=2&s=15&a=43&i=0&ac=0", rel: "next", type: "GET"}
        var next = _.find(vm.links, function(o) {
            return o.rel === 'next';
        });

        $state.go('order.purchaseorderanalysis', {
            s: vm.selectedSupplier.id,
            limit: next.limit,
            a: vm.selectedArticleCollection.id,
            page: next.page,
            i: vm.includeInactive ? '1': '0',
            ac: vm.showAllCollections ? '1': '0'
        });
    }
    function goToLast() {
        // 4: {href: "order/purchaseorderanalysis?limit=300&page=6&s=15&a=43&i=0&ac=0", rel: "last", type: "GET"
        var last = _.find(vm.links, function(o) {
            return o.rel === 'last';
        });

        $state.go('order.purchaseorderanalysis', {
            s: vm.selectedSupplier.id,
            limit: last.limit,
            a: vm.selectedArticleCollection.id,
            page: last.page,
            i: vm.includeInactive ? '1': '0',
            ac: vm.showAllCollections ? '1': '0'
        });
    }

    function showFilterDialog() {
        purchaseOrderAnalysisFilterDialogService
            .showDialog(
                vm.selectedSupplier,
                vm.suppliers,
                vm.selectedNumberOfResultsPerPage,
                vm.numberOfResultsPerPage,
                vm.selectedArticleCollection,
                vm.articleCollections,
                vm.showAllCollections,
                vm.selectedMainGroup,
                vm.allMainGroups,
                vm.selectedWeekLimit,
                vm.weekLimit,
                vm.keepProductTogether,
                vm.showWeeks,
                vm.showProduct,
                vm.includeInactive
            )
            .then(function(response) {
                if (response.confirmation) {
                    var reloadArticles = false;

                    if (response.selectedSupplier && response.selectedSupplier.id !== vm.selectedSupplier.id) {
                        reloadArticles = true;
                    }

                    if (response.selectedArticleCollection && (!vm.selectedArticleCollection || response.selectedArticleCollection.id !== vm.selectedArticleCollection.id)) {
                        vm.selectedArticleCollection = response.selectedArticleCollection;
                        reloadArticles = true;
                    }
                    if (response.includeInactive !== vm.includeInactive) {
                        vm.includeInactive = response.includeInactive;
                        reloadArticles = true;
                    }
                    if (response.selectedNumberOfResultsPerPage && (!vm.selectedNumberOfResultsPerPage || response.selectedNumberOfResultsPerPage !== vm.selectedNumberOfResultsPerPage)) {
                        vm.selectedNumberOfResultsPerPage = response.selectedNumberOfResultsPerPage;
                        reloadArticles = true;
                    }
                    if (response.showAllCollections !== vm.showAllCollections) {
                        vm.showAllCollections = response.showAllCollections;
                        reloadArticles = true;
                    }

                    if (reloadArticles) {
                        $state.go('order.purchaseorderanalysis', {
                            s: response.selectedSupplier.id,
                            limit: vm.selectedNumberOfResultsPerPage,
                            a: vm.selectedArticleCollection.id,
                            page: vm.currentPage,
                            i: vm.includeInactive ? '1': '0',
                            ac: vm.showAllCollections ? '1': '0'
                        });
                    }

                    var refilterArticles = false;
                    if (response.selectedMainGroup && (!vm.selectedMainGroup || response.selectedMainGroup.id !== vm.selectedMainGroup.id)) {
                        vm.selectedMainGroup = response.selectedMainGroup;
                        refilterArticles = true;
                    }
                    if (response.selectedWeekLimit !== vm.selectedWeekLimit) {
                        vm.selectedWeekLimit = response.selectedWeekLimit;
                        refilterArticles = true;
                    }
                    if (response.keepProductTogether !== vm.keepProductTogether) {
                        vm.keepProductTogether = response.keepProductTogether;
                        refilterArticles = true;
                    }
                    if (refilterArticles) {
                        filterAnalysisRows();
                    }

                    if (response.showWeeks !== vm.showWeeks) {
                        vm.showWeeks = response.showWeeks;
                    }
                    if (response.showProduct !== vm.showProduct) {
                        vm.showProduct = response.showProduct;
                        toggleShowProduct();
                    }
                }
            });
    }

    function loadPurchaseOrderAnalysis() {
        loadSpinnerService.start('mainSpinner');
        var request = {
            articleCollectionId: vm.selectedArticleCollection.id,
            includeInactive: vm.includeInactive,
            includeAllArticleCollections: vm.showAllCollections,
            limit: vm.selectedNumberOfResultsPerPage,
            page: vm.currentPage,
            supplierId: vm.selectedSupplier.id
        };
        PurchaseOrderAnalysisApiService.getPurchaseOrderAnalysis(request).then(function(response) {
            vm.completeListOfPurchageAnalysisRows = response !== null && response.data !== null && response.data.results !== null ? response.data.results : [];
            vm.currentPage = response.data.page;
            vm.links = response !== null && response.links !== null ? response.links : [];

            _.forEach(vm.completeListOfPurchageAnalysisRows, function(article) {
                //Add default value for quantity to order
                _.forEach(article.articleVariants, function (row) {
                    row.quantityToOrder = 0;
                });
                //Make a copy of all article variants to use while filtering
                article.completeListOfArticleVariants = article.articleVariants;
            });
            //Make sure no article variant rows are show at default
            _.forEach(vm.completeListOfPurchageAnalysisRows, function(article) {
                article.showRows = false;
                if (vm.showProduct === false) {
                    article.showRows = true;
                }
                _.forEach(article.articleVariants, function (row) {
                    row.showRow = true;
                });
            });
            filterAnalysisRows();
        }, function (error) {
            ToasterService.showError(error, $translate.instant('common.error'));
        }).finally(function () {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function filterAnalysisRows() {
        loadSpinnerService.start('mainSpinner');

        vm.purchaseOrderAnalysisArticles = vm.completeListOfPurchageAnalysisRows;

        //First filter by selected main group
        if (vm.selectedMainGroup && vm.selectedMainGroup.id > 0) {
            vm.purchaseOrderAnalysisArticles = _.filter(vm.purchaseOrderAnalysisArticles, function(article) {
                return article.mainGroupId === vm.selectedMainGroup.id;
            });
        }

        //Second filter by articles' stock value, taking in account if all article variants are below threshold
        if (vm.selectedWeekLimit) {
            if (vm.keepProductTogether === true) {
                vm.purchaseOrderAnalysisArticles = _.filter(vm.purchaseOrderAnalysisArticles, function(article) {
                    return !_.every(article.articleVariants, function (row) {
                        return row.weeksLeftInStock > vm.selectedWeekLimit;
                    });
                });
            } else {
                vm.purchaseOrderAnalysisArticles = _.filter(vm.purchaseOrderAnalysisArticles, function(article) {
                    return _.every(article.articleVariants, function (row) {
                        return row.weeksLeftInStock < vm.selectedWeekLimit;
                    });
                });
            }
        }

        vm.purchaseOrderAnalysisArticlesLength = Object.keys(vm.purchaseOrderAnalysisArticles).length;

        //Filter list of maingroups depending on which are shown, to prevent choosing a group that is not shown
        vm.mainGroups = _.filter(vm.allMainGroups, function(mg) {
            var index = _.findIndex(vm.completeListOfPurchageAnalysisRows, function(article) {
                return article.mainGroupId === mg.id;
            });
            return index > -1;
        });
        vm.mainGroups.unshift({
            id: -1,
            mainGroupCode: ' ',
            mainGroupDescription: ' '
        });

        loadSpinnerService.stop('mainSpinner');
    }

    function createOrder() {
        var listOfArticles = angular.copy(vm.completeListOfPurchageAnalysisRows);
        listOfArticles = _.filter(listOfArticles, function(article) {
            var sum = 0;
            sum = _.sumBy(article.articleVariants, function(row) {
                return row.quantityToOrder;
            });
            return sum > 0;
        });

        var message = $translate.instant('purchaseorderanalysis.confirmCreateOrder') + '<br><br>';
        message += '<table style="width:100%">' +
            '<thead>' +
            '<th colspan="2">' + $translate.instant('article.article') + '</th>' +
            '<th>' + $translate.instant('article.variantdetail1') + '</th>' +
            '<th>' + $translate.instant('article.variantdetail2') + '</th>' +
            '<th>' + $translate.instant('common.quantity') + '</th>' +
            '</thead>';
        _.forEach(listOfArticles, function(article) {
            message += '<tr>' +
                '<td>' + article.productNumber + '</td>' +
                '<td>' + article.productName + '</td>' +
                '<td colspan="3">&nbsp;</td>' +
                '</tr>';
            _.forEach(article.completeListOfArticleVariants, function(articleVariant) {
                if (articleVariant.quantityToOrder && articleVariant.quantityToOrder > 0) {
                    message += '<tr>' +
                        '<td>&nbsp;</td>' +
                        '<td>&nbsp;</td>' +
                        '<td>' + articleVariant.variantDetail1 + '</td>' +
                        '<td>' + articleVariant.variantDetail2 + '</td>' +
                        '<td>' + articleVariant.quantityToOrder + '</td>' +
                        '</tr>';
                }
            });
        });
        message += '</table>';
        confirmationDialogService.showDialog(message).then(function (result) {
            if (result === true) {
                $state.go('order.new', {
                    orderSystemType: 'store',
                    supplierId: vm.selectedSupplier.id,
                    articles: listOfArticles
                });
            }
        });
    }

    function toggleShowProduct() {
        _.forEach(vm.purchaseOrderAnalysisArticles, function(article) {
            article.showRows = !vm.showProduct;
        });
    }
    function toggleArticleRows(article) {
        if (!article.showRows) { article.showRows = false; }
        article.showRows = !article.showRows;
    }

    function weeksLeftInStockAfterOrder(row) {
        var averageSales = averageSalesPerWeek(row);
        if (averageSales <= 0) { return 0; }
        var weeksLeft = (row.currentWarehouseStockQuantity + row.orderedQuantity + row.quantityToOrder) / averageSales;
        return weeksLeft;
    }

    function monthsLeftInStockAfterOrder(row) {
        var averageSales = averageSalesPerMonth(row);
        if (averageSales === 0) { return 0; }
        var monthsLeft = (row.currentWarehouseStockQuantity + row.orderedQuantity + row.quantityToOrder) / averageSales;
        return monthsLeft;
    }

    function averageSalesPerWeek(row) {
        var averageSales =  (row.week1 + row.week2 + row.week3 + row.week4 +
                            row.week5 + row.week6 + row.week7 + row.week8 +
                            row.week9 + row.week10 + row.week11 + row.week12) / 12;
        return averageSales;
    }

    function averageSalesPerMonth(row) {
        var averageSales = averageSalesPerWeek(row) * 4;
        return averageSales;
    }

    function sumRowsWeek(article, weekNo) {
        var sum = 0;
        switch (weekNo) {
            case 1: sum = _.sumBy(article.articleVariants, function(o) { return o.week1; }); break;
            case 2: sum = _.sumBy(article.articleVariants, function(o) { return o.week2; }); break;
            case 3: sum = _.sumBy(article.articleVariants, function(o) { return o.week3; }); break;
            case 4: sum = _.sumBy(article.articleVariants, function(o) { return o.week4; }); break;
            case 5: sum = _.sumBy(article.articleVariants, function(o) { return o.week5; }); break;
            case 6: sum = _.sumBy(article.articleVariants, function(o) { return o.week6; }); break;
            case 7: sum = _.sumBy(article.articleVariants, function(o) { return o.week7; }); break;
            case 8: sum = _.sumBy(article.articleVariants, function(o) { return o.week8; }); break;
            case 9: sum = _.sumBy(article.articleVariants, function(o) { return o.week9; }); break;
            case 10: sum = _.sumBy(article.articleVariants, function(o) { return o.week10; }); break;
            case 11: sum = _.sumBy(article.articleVariants, function(o) { return o.week11; }); break;
            case 12: sum = _.sumBy(article.articleVariants, function(o) { return o.week12; }); break;
            default:
                sum = 0;
        }
        return sum;
    }
    function sumRowsMonth(article, monthNo) {
        var sum = 0;
        switch (monthNo) {
            case 1: sum = _.sumBy(article.articleVariants, function(row) { return calculateMonth(1, row); }); break;
            case 2: sum = _.sumBy(article.articleVariants, function(row) { return calculateMonth(2, row); }); break;
            case 3: sum = _.sumBy(article.articleVariants, function(row) { return calculateMonth(3, row); }); break;
            default:
                sum = 0;
        }
        return sum;
    }
    function sumQuantityToOrder(article) {
        var sum = _.sumBy(article.articleVariants, function(row) {
            return row.quantityToOrder;
        });
        return sum;
    }
    function sumTotalQuantityToOrder() {
        var sum = 0;
        _.forEach(vm.completeListOfPurchageAnalysisRows, function(article) {
            sum += _.sumBy(article.completeListOfArticleVariants, function(row) {
                return row.quantityToOrder;
            });
        });
        return sum;
    }
    function sumWarehouseStock(article) {
        var sum = _.sumBy(article.articleVariants, function(row) {
            return row.currentWarehouseStockQuantity;
        });
        return sum;
    }
    function sumStoreStock(article) {
        var sum = _.sumBy(article.articleVariants, function(row) {
            return row.currentStoreStockQuantity;
        });
        return sum;
    }
    function sumOrderedQuantity(article) {
        var sum = _.sumBy(article.articleVariants, function(row) {
            return row.orderedQuantity;
        });
        return sum;
    }
    function sumWeeksLeftInStock(article) {
        var sum = _.sumBy(article.articleVariants, function(row) {
            return row.weeksLeftInStock;
        });
        return sum;
    }
    function sumMonthsLeftInStock(article) {
        //Generalize month to four weeks
        var sum = 0;
        _.forEach(article.articleVariants, function(row) {
            sum += row.weeksLeftInStock / 4;
        });
        return sum;
    }

    function sumRowWeeksLeftInStock(row) {
        var sum = row.weeksLeftInStock;
        return sum;
    }
    function sumRowMonthsLeftInStock(row) {
        var sum = row.weeksLeftInStock / (4); //Month is generalized to four weeks
        return sum;
    }

    function showChangedWeekAverage(row) {
        var weeksLeftInStockAfterOrder = (vm.weeksLeftInStockAfterOrder(row)).toFixed(2);
        var sumRowWeeksLeftInStock = (vm.sumRowWeeksLeftInStock(row)).toFixed(2);

        return weeksLeftInStockAfterOrder > sumRowWeeksLeftInStock;
    }

    function showChangedMonthAverage(row) {
        var monthsLeftInStockAfterOrder = (vm.monthsLeftInStockAfterOrder(row)).toFixed(2);
        var sumRowMonthsLeftInStock = (vm.sumRowMonthsLeftInStock(row)).toFixed(2);

        return monthsLeftInStockAfterOrder > sumRowMonthsLeftInStock;
    }

    function canCreateOrder() {
        var sum = 0;
        _.forEach(vm.purchaseOrderAnalysisArticles, function(article) {
            sum += _.sumBy(article.articleVariants, function(row) {
                return row.quantityToOrder;
            });
        });

        return sum > 0;
    }

    function calculateMonth(monthNo, row) {
        switch (monthNo) {
            case 1:
                return row.week1 + row.week2 + row.week3 + row.week4;
            case 2:
                return row.week5 + row.week6 + row.week7 + row.week8;
            case 3:
                return row.week9 + row.week10 + row.week11 + row.week12;
        }
    }

    function clearFilter() {
        vm.selectedNumberOfResultsPerPage = 300;
        vm.includeInactive = false;
        vm.selectedArticleCollection = _.find(vm.articleCollections, { 'isCurrent': true });
        vm.selectedMainGroup = undefined;
        vm.selectedWeekLimit = undefined;
        filterAnalysisRows();
    }
}

angular
    .module('order.purchaseorderanalysis', [])
    .config(stateConfig)
    .controller('PurchaseOrderAnalysisController', PurchaseOrderAnalysisController);
